(function ($) {
  Drupal.behaviors.blogAccordionFormatterV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $template = $('.js-blog-accordion-formatter-v1', context);
      var $trigger = $('.js-blog-accordion-formatter__toggle', $template);
      var toggleAccordion = function ($this) {
        var $parent = $this.parent();
        var $content = $parent.next('.js-blog-accordion-formatter__items');
        // Cast the expanded state as a boolean
        var expanded = $parent.attr('aria-expanded') === 'false' ? false : true;

        // Switch the states of aria-expanded and aria-hidden
        $parent.attr('aria-expanded', !expanded);
        $content.attr('aria-hidden', expanded);
      };

      // Check if this has a trigger
      if ($trigger.length) {
        // Toggle the nav
        $trigger.once('blog-accordion-formatter-v1-toggle')
          .on('click', function () {
            toggleAccordion($(this));
          })
          .on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
              event.preventDefault();
              toggleAccordion($(this));
            }
          });
      }
    }
  };
})(jQuery);
